import { MobileSignInQrCodeDialogComponent } from '../components/mobile-sign-in-qr-code-dialog/mobile-sign-in-qr-code-dialog.component';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PplDialogService } from '@ppl/ui/dialog';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { HttpErrorResponse } from '@angular/common/http';
import type { MobileSignInQrCodeDialogData } from '../components/mobile-sign-in-qr-code-dialog/mobile-sign-in-qr-code-dialog.component';
import type { MobileSignInSession } from '../domain/mobile-sign-in';

@Injectable({
  providedIn: 'root'
})
export class MobileSignInService {

  private securityTokenExpiry$ = new Subject<{ securityToken: string }>();

  get securityTokenExpired$() {
    return this.securityTokenExpiry$.asObservable();
  }

  constructor(
    private dialogService: PplDialogService,
    private http: HttpClient
  ) { }

  fetchSessions() {
    return this.http.get<MobileSignInSession[]>(
      `/rest/logins`,
      {
        responseType: 'json',
        withCredentials: true
      }
    );
  }

  deleteSession(options: {
    id: number;
    securityToken: string;
  }) {
    return this.securityDelete(`/rest/logins/${options.id}`, options.securityToken);
  }

  openQrCodeDialog(options: {
    securityToken: string;
  }) {
    return this.dialogService.open<MobileSignInQrCodeDialogComponent, MobileSignInQrCodeDialogData>(MobileSignInQrCodeDialogComponent, {
      data: {
        onSessionExpiration: data => {
          this.securityTokenExpiry$.next(data);
        },
        securityToken: options.securityToken
      }
    }).afterClosed();
  }

  private securityDelete<T>(
    url: string,
    securityToken: string
  ) {
    return this.http.delete<T>(
      url,
      {
        body: {
          security_token: securityToken
        }
      }
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          this.securityTokenExpiry$.next({ securityToken });
        }

        return throwError(error);
      })
    );
  }

}
